import WhoWeAre from "../components/WhoWeAre/WhoWeAre";
import styles from "./Company.module.scss";

const Company = () => {
  return <WhoWeAre />;
};

export default Company;
